import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import { Field, ErrorMessage } from "formik";
import BootstrapTable from "react-bootstrap-table-next";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

class FillerViewVerifyAndAccept extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    
    this.products1 = [
        {
          id: "01",
          categories: "HPHT",
          weight: 1.5,
          pieces: 1,
          inward: "",
          assignProcess: 2,
        },
        {
          id: "02", 
          categories: "LPHT",
          weight: 1.5,
          pieces: 1,
          inward: "",
          assignProcess: 8,
        },
        {
          id: "03",
          categories: "REAL",
          weight: 1.5,
          pieces: 1,
          inward: "",
          assignProcess: 5,
        },
        {
          id: "04",
          categories: "JIRAM",
          weight: 1.5,
          pieces: 1,
          inward: "",
          assignProcess: 10,
        },
      ];
  }


  render() {

    this.columns2 = [
        {
          dataField: "id",
           text: `${this.props.t("Sr.No.")}`,
          footer: `${this.props.t("Total")}`,
        },
        {
          dataField: "categories",
          text: "Categories",
          footer: "",
        },
        {
          dataField: "weight",
          text: `${this.props.t('Weight / Carat')}`,
          footer: "",
          footer: columnData =>
            columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        },
        {
          dataField: "pieces",
          text:`${this.props.t('Pieces')}`,
          footer: "",
          footer: columnData =>
            columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        },
        {
          dataField: "inward",
          text: `${this.props.t('Self Internal Remarks')}`,
          footer: "",
        },
        {
          dataField: "assignProcess",
          text: "Assigned Process",
          footer: "",
        },
      ];
    //meta title
    document.title = "filler flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="To Receive & Verify & Accept" />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-lg-flex d-block justify-content-between">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                        To Receive & Verify & Accept
                        </h4>
                      </div>
                      {/* <div>
                        <label
                          htmlFor="date"
                          className="pe-2 fs-5 fw-bold text-black"
                        >
                          Date:
                        </label>
                        <input
                          disabled
                          type="date"
                          className="fs-5 border-0 text-black bg-white"
                        />
                      </div> */}
                    </div>
                        <form>
                            <div className="mb-3 row">
                              <label
                                htmlFor="inwardID"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Jangad No')}
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="inwardID"
                                  placeholder="JANGAD0000123"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="partyCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Party Code')}
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  type="text"
                                  name="partyCode"
                                  placeholder="COMPANY000123"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="hpht"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">HPHT</h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="hpht"
                                  placeholder="12"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label
                                htmlFor="lpht"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">LPHT</h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="lpht"
                                  placeholder="12"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="real"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">REAL</h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="real"
                                  placeholder="12"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="jiram"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  JIRAM
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="jiram"
                                  placeholder="12"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label
                                htmlFor="weight"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Weight
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5" 
                                  disabled
                                  type="text"
                                  name="weight"
                                  placeholder="20.25 CT"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="pieces"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Pieces
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="pieces"
                                  placeholder="12"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="inwardDate"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Inward Date
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="inwardDate"
                                  placeholder="26/01/2022"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="inwardDate"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                {this.props.t('Grader Notes')}
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <textarea className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="inwardDate"
                                  placeholder="Please Take of HPHL First Priority"
                                  rows="5">                                
                                  </textarea>
                              </div>
                            </div>

                            <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                          To Assign Stock Details Summary
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.products1}
                            columns={this.columns2}
                          />
                        </div>
                      </div>
                          </form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(FillerViewVerifyAndAccept);
